window.addEventListener('load', () => {
	const watcher = document.querySelector('.scroll-watcher');

	if (watcher && !CSS.supports('animation-timeline: scroll()')) {
		const updateScrollWatcher = () => {
			const scrollTop = window.scrollY;
			const scrollHeight =
				document.documentElement.scrollHeight - window.innerHeight;
			const progress = scrollHeight > 0 ? scrollTop / scrollHeight : 0;

			watcher.style.transform = `scaleX(${progress})`;
		};

		window.requestAnimationFrame(updateScrollWatcher);
		window.addEventListener('scroll', updateScrollWatcher, { passive: true });
		window.addEventListener('resize', updateScrollWatcher);
	}
});